import clsx from 'clsx';
import React, { FC, HTMLProps, memo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ScheduledOrder.module.scss';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { SCHEDULED_ORDER_IDS } from './ScheduledOrder.consts';
import { useScheduledOrderDisplay } from 'hooks/context/ScheduledOrderDisplay';
import { DropdownItem } from './DropdownItem/DropdownItem';

export type ScheduledOrderProps = HTMLProps<HTMLElement> & {
  selectClassName?: string;
};

export const ScheduledOrder: FC<ScheduledOrderProps> = memo(function ScheduledOrder({ selectClassName }) {
  const { t } = useTranslation();
  const { dates, times, displayValueDate, displayValueTime, updateDisplayValueDate, updateDisplayValueTime } = useScheduledOrderDisplay();
  const [firstDate] = dates;
  const [firstTime] = times;

  return (
    <>
      <Dropdown
        readonly={dates.length === 0}
        label={t('cart.date')}
        defaultValue={displayValueDate?.label || firstDate?.label}
        iconName={'calendar'}
        selectClassName={clsx(styles.dateDropdown, selectClassName)}
        dataTestId={SCHEDULED_ORDER_IDS.date}
      >
        {dates.map((item, index) => (
          <DropdownItem
            className={styles.item}
            key={index}
            value={item.label}
            data-testid={item.label.toLowerCase()}
            onClick={() => updateDisplayValueDate(item)}
          >
            <div className={clsx(styles.name)} title={item.label}>
                {item.label}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
      <Dropdown
        readonly={times.length === 0}
        label={t('cart.time')}
        defaultValue={displayValueTime?.label || firstTime?.label}
        iconName={'clock'}
        selectClassName={clsx(styles.timeDropdown, selectClassName)}
        dataTestId={SCHEDULED_ORDER_IDS.time}
      >
        {times.map((item, index) => (
          <DropdownItem
            className={styles.item}
            key={index}
            value={item.label}
            data-testid={item.label.toLowerCase()}
            onClick={() => updateDisplayValueTime(item)}
          >
            <div className={clsx(styles.name)}>
            {item.label}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </>
  );
});
